import { route, string } from 'react-router-typesafe-routes/dom'
export const DATABASES_ROUTES = {
  databases: route('et/company/:companyId/databases', {
    params: { companyId: string().defined() },
  }),
}
